import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Modal from 'react-bootstrap/lib/Modal';
import Button from '@/shared/components/Button';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import adminpulse from '@/shared/utils/adminpulse';
const messages = defineMessages({
    EmailEditor: {
        id: 'EmailEditor',
        defaultMessage: 'E-mail editor',
    },
    SendTo: {
        id: 'SendTo',
        defaultMessage: 'Send to',
    },
    CC: {
        id: 'CC',
        defaultMessage: 'CC',
    },
    BCC: {
        id: 'BCC',
        defaultMessage: 'BCC',
    },
    Subject: {
        id: 'Subject',
        defaultMessage: 'Subject',
    },
    Content: {
        id: 'Content',
        defaultMessage: 'Content',
    },
    Cancel: {
        id: 'Cancel',
        defaultMessage: 'Cancel',
    },
    Send: {
        id: 'Send',
        defaultMessage: 'Send',
    },
    EmailSent: {
        id: 'EmailSent',
        defaultMessage: 'EmailSent',
    },
    SelectOrTypeEmail: {
        id: 'SelectOrTypeEmail',
        defaultMessage: 'Select or type an e-mail address',
    },
    AddEmailAddress: {
        id: 'AddEmailAddress',
        defaultMessage: 'Add e-mail address',
    },
    RemoveEmailAddress: {
        id: 'RemoveEmailAddress',
        defaultMessage: 'Remove e-mail address',
    },
    msgInvalidEmailAddress: {
        id: 'msgInvalidEmailAddress',
        defaultMessage: 'An invalid email address was entered.',
    },
});
const EmailAddressList = ({ addresses, onChange, onAdd, placeholder, addTitle, removeTitle, required = false, minEntries = 0, }) => (_jsxs("div", { children: [addresses.map((email, index) => (_jsxs("div", Object.assign({ className: "row margin10B" }, { children: [_jsx("div", Object.assign({ className: "col-sm-6" }, { children: _jsx("input", { type: "email", className: `form-control${required && !adminpulse.isValidEmail(email) ? ' markedError' : ''}`, value: email, onChange: e => {
                            const updated = [...addresses];
                            updated[index] = e.target.value;
                            onChange(updated);
                        }, placeholder: placeholder }) })), _jsx("div", Object.assign({ className: "col-sm-1" }, { children: addresses.length > minEntries && (_jsx("a", Object.assign({ className: "clickable", title: removeTitle, onClick: () => onChange(addresses.filter((_, i) => i !== index)) }, { children: _jsx("i", { className: "fa fa-remove" }) }))) }))] }), index))), _jsx("div", { children: _jsx("a", Object.assign({ className: "btn btn-default btn-xs", title: addTitle, onClick: onAdd }, { children: _jsx("i", { className: "fa fa-plus" }) })) })] }));
const MailEmailDomainCnameInfoModal = ({ show, onClose, companyId, }) => {
    const intl = useIntl();
    const [preview, setPreview] = useState(null);
    const [previewError, setPreviewError] = useState(null);
    const [sendTo, setSendTo] = useState(['']);
    const [cc, setCc] = useState([]);
    const [bcc, setBcc] = useState([]);
    const [sending, setSending] = useState(false);
    useEffect(() => {
        if (!show)
            return;
        setPreview(null);
        setPreviewError(null);
        api.base
            .get(`/api/settings/GetEmailDomainInfoMail?id=${companyId}`)
            .then(({ data }) => {
            var _a;
            if (data) {
                setPreview(data);
                if (((_a = data.cc) === null || _a === void 0 ? void 0 : _a.length) && cc.length === 0) {
                    setCc(data.cc);
                }
                if (sendTo.length === 0 || (sendTo.length === 1 && !sendTo[0])) {
                    setSendTo(['']);
                }
            }
        })
            .catch((error) => {
            setPreviewError('Error loading email preview');
            handleHttpError(intl)(error);
        });
    }, [show, companyId]);
    const validateEmails = (emails) => {
        for (const email of emails) {
            if (!adminpulse.isValidEmail(email)) {
                ToastrService.error(intl.formatMessage(messages.msgInvalidEmailAddress));
                return false;
            }
        }
        return true;
    };
    const handleSend = async () => {
        if (!preview || !preview.subject || !preview.body || sending)
            return;
        const filteredTo = sendTo.filter(e => e.trim());
        const filteredCc = cc.filter(e => e.trim());
        const filteredBcc = bcc.filter(e => e.trim());
        if (filteredTo.length === 0)
            return;
        if (!validateEmails(filteredTo))
            return;
        if (!validateEmails(filteredCc))
            return;
        if (!validateEmails(filteredBcc))
            return;
        setSending(true);
        try {
            const payload = Object.assign(Object.assign({}, preview), { to: filteredTo, cc: filteredCc, bcc: filteredBcc, recipients: filteredTo });
            await api.base.post('/api/settings/SendEmailDomainInfoMail', payload);
            ToastrService.success(intl.formatMessage(messages.EmailSent));
            onClose();
        }
        catch (error) {
            handleHttpError(intl)(error);
        }
        finally {
            setSending(false);
        }
    };
    const placeholder = intl.formatMessage(messages.SelectOrTypeEmail);
    const addTitle = intl.formatMessage(messages.AddEmailAddress);
    const removeTitle = intl.formatMessage(messages.RemoveEmailAddress);
    return (_jsxs(Modal, Object.assign({ show: show, onHide: onClose, dialogClassName: "modal-xl", enforceFocus: false, backdrop: "static" }, { children: [_jsx(Modal.Header, Object.assign({ closeButton: true }, { children: _jsx(Modal.Title, { children: intl.formatMessage(messages.EmailEditor) }) })), _jsx(Modal.Body, { children: _jsxs("div", Object.assign({ className: "form-horizontal", role: "form" }, { children: [_jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("div", Object.assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.SendTo) })), _jsx("div", Object.assign({ className: "col-sm-7" }, { children: _jsx(EmailAddressList, { addresses: sendTo, onChange: setSendTo, onAdd: () => setSendTo([...sendTo, '']), placeholder: placeholder, addTitle: addTitle, removeTitle: removeTitle, required: true, minEntries: 1 }) }))] })), _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("div", Object.assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.CC) })), _jsx("div", Object.assign({ className: "col-sm-7" }, { children: _jsx(EmailAddressList, { addresses: cc, onChange: setCc, onAdd: () => setCc([...cc, '']), placeholder: placeholder, addTitle: addTitle, removeTitle: removeTitle }) }))] })), _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("div", Object.assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.BCC) })), _jsx("div", Object.assign({ className: "col-sm-7" }, { children: _jsx(EmailAddressList, { addresses: bcc, onChange: setBcc, onAdd: () => setBcc([...bcc, '']), placeholder: placeholder, addTitle: addTitle, removeTitle: removeTitle }) }))] })), preview && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("div", Object.assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.Subject) })), _jsx("div", Object.assign({ className: "col-sm-10" }, { children: _jsx("input", { type: "text", className: "form-control", maxLength: 500, value: preview.subject || '', onChange: e => setPreview(Object.assign(Object.assign({}, preview), { subject: e.target.value })), required: true }) }))] })), _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("div", Object.assign({ className: "col-sm-2 control-label" }, { children: intl.formatMessage(messages.Content) })), _jsx("div", Object.assign({ className: "col-sm-10" }, { children: _jsx("div", { className: "form-control", style: { height: 'auto', minHeight: 200 }, contentEditable: true, dangerouslySetInnerHTML: { __html: preview.body || '' }, onBlur: e => setPreview(Object.assign(Object.assign({}, preview), { body: e.currentTarget.innerHTML })) }) }))] }))] })), previewError && (_jsx("div", Object.assign({ className: "form-group" }, { children: _jsx("div", Object.assign({ className: "errorMsg col-sm-offset-2 col-sm-10" }, { children: previewError })) })))] })) }), _jsxs(Modal.Footer, { children: [_jsx(Button, Object.assign({ onClick: onClose, disabled: sending, name: "MailCnameInfo-Cancel" }, { children: intl.formatMessage(messages.Cancel) })), _jsx(Button, Object.assign({ onClick: handleSend, disabled: sending || !(preview === null || preview === void 0 ? void 0 : preview.subject) || !(preview === null || preview === void 0 ? void 0 : preview.body), btnClassName: "btn-inverse", name: "MailCnameInfo-Send" }, { children: intl.formatMessage(messages.Send) }))] })] })));
};
export default MailEmailDomainCnameInfoModal;
